'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * createWorkerSource
 * For creating dedicated web worker source dynamically.
 * @module utils/createWorkerSource.js
 * @author @SurenAt93
 */

var createWorkerSource = function createWorkerSource(isFunction, source) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fnName = arguments[3];
  var transformedDeps = deps.map(function (item) {
    return '\'' + item + '\'';
  }).join(',');
  var transformedSource = '\n    importScripts(' + transformedDeps + ');\n    ' + (isFunction ? 'const fn = ' + source + ';' : ';' + source + '; const fn = ' + fnName) + '\n\n    self.onmessage = msg => {\n      const result = fn(msg.data);\n      self.postMessage(result);\n    }\n  ';
  return transformedSource;
};

exports.default = createWorkerSource;